export default class ExtraData {
  public keyName: string;

  public keyValue: string;

  constructor(keyName: string, keyValue: string) {
    this.keyName = keyName;
    this.keyValue = keyValue;
  }
}
